<template>
  <USkeleton class="relative h-43 rounded-md overflow-hidden animate-none flex items-center justify-center">
    <div class="absolute inset-0 animate-shimmer bg-gradient-to-r from-transparent
              via-white/40 dark:via-white/10 to-transparent" />
    <h3 class="text-xl font-bold text-center px-4">
        {{ props.category }}
      </h3>
  </USkeleton>
</template>
<script setup lang="ts">
const props = defineProps<{category: string}>();

</script>